import { useEffect } from "react";
import Hero from "./components/Hero";
import USPs from "./components/USPs";
import HowItWorks from "./components/HowItWorks";
import SocialProof from "./components/SocialProof";
import VendorSlider from "./components/VendorSlider";
import Community from "./components/Community";
import Resources from "./components/Resources";
import CTABanner from "./components/CTABanner";

const BimDigitalTwinHome = () => {
	useEffect(() => {
		const addStickyHeader = () => {
			const header = document.querySelector("header");
			if (header) {
				header.style.position = "sticky";
				header.style.top = "0";
				header.style.zIndex = "50";
			}
		};

		const removeStickyHeader = () => {
			const header = document.querySelector("header");
			if (header) {
				header.style.position = "";
				header.style.top = "";
				header.style.zIndex = "";
			}
		};

		addStickyHeader();

		return () => {
			removeStickyHeader();
		};
	}, []);

	return (
		<div className="w-screen">
			<Hero />
			<USPs />
			<HowItWorks />
			<SocialProof />
			<VendorSlider />
			<Community />
			<Resources />
			<CTABanner />
		</div>
	);
};

export default BimDigitalTwinHome;
